import { render, staticRenderFns } from "./SetDiscount.vue?vue&type=template&id=d6867e7c&"
import script from "./SetDiscount.vue?vue&type=script&lang=js&"
export * from "./SetDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports